import { request, qs, toPage, type Page } from "@api/request";

export type NotificationKind = "info" | "success" | "warning" | "error";

export interface NotificationDto {
    id: string;
    title: string;
    message: string;
    type: NotificationKind | string;
    /** Stable event key (e.g. `delivery.recorded`); null on older rows. */
    code: string | null;
    data: Record<string, unknown>;
    url: string | null;
    readAt: string | null;
    createdAt: string;
}

export interface NotificationsPage extends Page<NotificationDto> {
    notifications: NotificationDto[];
    unreadCount: number;
}

export interface NotificationsQuery {
    page?: number;
    perPage?: number;
    status?: "read" | "unread";
}

export const notificationsApi = {
    list: async (params: NotificationsQuery = {}): Promise<NotificationsPage> => {
        const res = await request.get<Record<string, unknown>>(`/tenant/notification/list${qs({ ...params })}`);
        const page = toPage<NotificationDto>(res, "notifications");
        return {
            ...page,
            notifications: page.items,
            unreadCount: Number(res.unreadCount ?? 0),
        };
    },
    unreadCount: () => request.get<{ unreadCount: number }>("/tenant/notification/unread-count"),
    markRead: (id: string) => request.patch<{ message?: string }>(`/tenant/notification/${id}/read`),
    markAllRead: () => request.post<{ message?: string }>("/tenant/notification/mark-all-read"),
    delete: (id: string) => request.delete<{ message?: string }>(`/tenant/notification/${id}`),
};
